import React, { useCallback } from 'react';

import cx from 'classnames';
import Carousel from 'nuka-carousel';

import FocalImage from 'components/Layouts/Form/FormBuilder/FocalImage';
import Icon from 'components/shared/Icon';
import Triangle from 'components/shared/Icon/icons/Triangle';
import { getAssetSrcFromId } from 'utils/asset';
import { checkIsWebview } from 'utils/mobileApplication';

import styles from './index.module.css';

function Slider(props) {
  const { files = [], showLegend } = props;

  const sliderArrow = <Icon component={Triangle} className={styles.sliderArrow} />;
  const onSlide = useCallback((props, count) => {
    const desired = (props.currentSlide + count) % props.slideCount;

    props.goToSlide(desired < 0 ? props.slideCount - 1 : desired);
  }, []);
  const isWebview = checkIsWebview();

  return (
    <div className={styles.wrapper}>
      <Carousel
        slidesToShow={1}
        renderCenterLeftControls={(props) => (
          <button
            onClick={() => {
              onSlide(props, -1);
            }}
            className={cx(styles.control, styles.prev)}
          >
            {sliderArrow}
          </button>
        )}
        renderCenterRightControls={(props) => (
          <button
            onClick={() => {
              onSlide(props, +1);
            }}
            className={cx(styles.control, styles.next)}
          >
            {sliderArrow}
          </button>
        )}
      >
        {files.map((image, i) => (
          <div key={i}>
            <div className={styles.imgBlock}>
              <FocalImage src={getAssetSrcFromId(image?.id)} point={image?.imageCoords} noLazyLoading={isWebview} />
              {showLegend && <div className={styles.legend}>{image.name}</div>}
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );
}

export default Slider;
